import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW5800Component } from './kymw5800.component';
import { GetCwsPlanGoodsCategoryListService } from './api-services/get-cws-plan-goods-category-list.service';

/**
 * EC企画商品別カテゴリ設定一覧表画面 モジュール設定クラス
 *
 * @export KYMW5800Module
 * @class KYMW5800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW5800Component,
  ],
  providers: [
    GetCwsPlanGoodsCategoryListService,
  ],
})
export class KYMW5800Module {

}
